"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clickable = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = require("../Box");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cursor = (0, _styledSystem.system)({
  cursor: true
});
var textDecoration = (0, _styledSystem.system)({
  textDecoration: true
});
/**
 * ClickableProps
 */

/**
 * Clickable is a utility component useful for wrapping things like <div>s
 * without having to deal with the requirements to make the <div> accessible.
 */
var Clickable = _styledComponents.default.button.withConfig({
  displayName: "Clickable",
  componentId: "sc-10cr82y-0"
})(["appearance:none;padding:0;border:0;background-color:transparent;", ""], (0, _styledSystem.compose)(_Box.boxMixin, cursor, textDecoration));

exports.Clickable = Clickable;
Clickable.defaultProps = {
  cursor: "pointer"
};
//# sourceMappingURL=Clickable.js.map